<template>
    <div>
        <Loader :is-visible="isLoading"></Loader>
        <div class="header grid">
            <div class="header__logo">
                <img src="./../assets/images/logo/logo.d5273f0.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import Loader from './../components/Loader.vue';

export default {
    components: {
        Loader
    },
    data () {
        return {
            showMenu: false,
            isLoading: false,
        }
    },
}
</script>